import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import Icon from '~/Common-Objects/UI/Icon'
import Icons from '~/Common-Objects/UI/Icons/index'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'
import copy from 'copy-to-clipboard'
import { alterSnackbar } from '~/data/actions/siteActions'
import TwoColPaperExplainer from '~/Common-Objects/DomainManagement/Components/TwoColPaperExplainer'
import TierLimitHolder from '~/Common-Objects/UI/Cards/TierLimitHolder'

export default function CDNSettings({
    updateDomain,
    setFlowStep,
    domainProvider,
    domainRecords,
    finishedFlow = () => {},
    domain,
    subDomain = '',
    finish = () => {}
}) {
    const site = useSelector((state) => state.siteMaster)
    const account = useSelector((state) => state.accountMaster)
    const dispatch = useDispatch()
    const copyVal = (val) => {
        copy(val)
        dispatch(alterSnackbar(true, 'Copied to clipboard'))
    }

    const [isLoading, setIsLoading] = useState(false)

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            finishUp(false)
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown)
        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [])

    const needsUpsell = account.accountMaster.accountType === 'free' && site.siteId === 1

    const newRecordsData = domainRecords
        .filter((record) => record.type == 'CDN')
        .map((record) => {
            const cdnDomainHost = domain?.cdnDomain?.domainName
                ? domain.cdnDomain.domainName.replace('.' + domain.domainName, '')
                : record.host
            let finalHost = record.host
            if (subDomain) {
                finalHost = finalHost + '.' + subDomain
            }
            return {
                type: {
                    headerValue: 'Type',
                    value: <SquareChip>{record.recordType}</SquareChip>
                },
                host: {
                    headerValue: 'Host',
                    value: (
                        <TextInput
                            readOnly={true}
                            value={finalHost}
                            iconRight={
                                <Icon
                                    name='copy'
                                    onClick={() => {
                                        copyVal(finalHost)
                                    }}
                                />
                            }
                        />
                    )
                },
                value: {
                    headerValue: 'Value/Target',
                    value: (
                        <TextInput
                            readOnly={true}
                            value={record.value}
                            iconRight={
                                <Icon
                                    name='copy'
                                    onClick={() => {
                                        copyVal(record.value)
                                    }}
                                />
                            }
                        />
                    )
                }
            }
        })

    const finishUp = async (skip = false) => {
        setIsLoading(true)
        await updateDomain({
            options: {
                cdnEnabled: !skip
            }
        })
        finishedFlow()
    }

    if (needsUpsell) {
        return (
            <TierLimitHolder
                err='tierForbids'
                feature='cdnDomains'
                tierName={account.tier.name}
                upsell={{ name: 'Starter' }}
                type='CDN Subdomains'
                newLayout={true}
                noMarg={true}
                onUpgradeClickSilently={finish}
                inline={true}
                buttonClassName='button-primary'
                className='warning-holder-transparent'
                description={i18n.t('company:domains.domainManagement.cdnExplainerContent')}
                extraCta={
                    <Button
                        text={i18n.t('company:domains.domainManagement.continueAndVerify')}
                        iconRight={<Icons icon='arrowRight' />}
                        className='button-sml'
                        onClick={() => finishUp(true)}
                        disabled={isLoading}
                    />
                }
            />
        )
    }

    return (
        <>
            <div>{i18n.t('company:domains.domainManagement.addRecord', { provider: domainProvider?.label })}</div>
            <DataTable1
                tableData={newRecordsData}
                loadingData={[]}
                dataUpdater={() => {}}
                width='100%'
                pageSize='100'
                hasCheckBoxes='no'
                sortedColumn={''}
                sortedDirection={''}
                className='mar-b20'
            />

            <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
                <Button
                    text={i18n.t('company:domains.domainManagement.continueAndVerify')}
                    iconRight={<Icons icon='arrowRight' />}
                    className='button-primary'
                    onClick={() => finishUp(false)}
                    disabled={isLoading}
                />

                {!isLoading && (
                    <a onClick={() => finishUp(true)} disabled={isLoading}>
                        {i18n.t('company:domains.domainManagement.skip')}
                    </a>
                )}
            </div>

            <TwoColPaperExplainer
                className='mar-t20 mar-b5'
                title={i18n.t('company:domains.domainManagement.cdnExplainerTitle')}
                content={i18n.t('company:domains.domainManagement.cdnExplainerContent')}
            />
        </>
    )
}
